import React from "react";
import { iconData } from "./config";
import {
  Container,
  MainContainer,
  InnerTopContainer,
  Heading,
  Description,
  BottomContainer,
  InnerBottomContainer,
  Icon,
  Title,
  IconDescription,
  IconContainer,
  Circle,
} from "./styled.components";
const OurServices = () => {
  return (
    <Container>
      <MainContainer>
        <InnerTopContainer>
          <Heading>Our Services</Heading>
          <Description>
            HHH offers a spectrum of services encompassing project planning,
            design, execution,<br></br> and management for residential,
            commercial, and infrastructure projects.
          </Description>
        </InnerTopContainer>
        <BottomContainer>
          <InnerBottomContainer>
            {iconData.map((_icon) => {
              return (
                <>
                  <IconContainer>
                    <Circle>
                      <Icon src={_icon.icon} />
                    </Circle>
                    <Title>{_icon.title}</Title>
                    <IconDescription>{_icon.description}</IconDescription>
                  </IconContainer>
                </>
              );
            })}
          </InnerBottomContainer>
        </BottomContainer>
      </MainContainer>
    </Container>
  );
};

export default OurServices;
